import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ManufacturerService } from 'src/app/_service/manufacturer.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AppCustomDirective } from 'src/app/_extensions/app.validators';

@Component({
  selector: 'edit-manufacturer',
  templateUrl: './edit-manufacturer.component.html',
  styleUrls: ['./edit-manufacturer.component.css']
})
export class EditManufacturerComponent implements OnInit {

  editManufacturerForm: FormGroup;
  manufacturer: any = {
    manufacturerName: '',
    url: '',
    sdsUrl: '',
    alternateName: '',
    notes: '',
    contactLocationId: 0,
    mostrecentcontact: null,
    contactEmail: '',
    contactUrl: '',
    contactPhoneNumber: '',
    contactFaxNumber: '',
    contactDetails: '',
    effectiveContactMethod: []
  };
  updateManufacturer: any;
  updatedContactLocationId: any;
  isModified = false;
  isDeleted = false;
  confirmModal = false;
  loading = false;

  manu: any;
  show = false;

  checkProductManufacturer: any = {};

  effectiveContactMethodArray: any = [];
  emailChecked = false;
  formUrlChecked = false;
  phoneChecked = false;
  faxChecked = false;

  today = new Date();
  limitDate: any = {};

  manufacturerUrl: any;
  sdsURL: any;
  
  DaterForm: FormGroup;

constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private manufacturerService: ManufacturerService,
    private alertify: AlertifyService,
    private router: Router,
    public fb: FormBuilder,
    private dialog: MatDialog,
    public cdr: ChangeDetectorRef
  ) {
    this.DaterForm = this.fb.group(
      {
        FromDate: ['', [AppCustomDirective.fromDateValidator]]
      });
      
    this.editManufacturerForm = fb.group({
      manufacturerNameFormControl: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.maxLength(250)
      ]),
      urlFormControl: new FormControl('', [Validators.maxLength(500)]),
      sdsUrlFormControl: new FormControl('', [Validators.maxLength(500)]),
      alternativeNamesFormControl: new FormControl('', [Validators.maxLength(250)]),
      notesFormControl: new FormControl('', [Validators.maxLength(1000)]),
      contactLocationFormControl: new FormControl('', []).clearValidators(),
      mostRecentContactFormControl: new FormControl('', []).clearValidators(),
      // Effective contact method
      emailContactFormControl: new FormControl('', [Validators.maxLength(75)]),
      formUrlContactFormControl: new FormControl('', [Validators.maxLength(125)]),
      phoneContactFormControl: new FormControl('', [Validators.maxLength(20)]),
      faxContactFormControl: new FormControl('', [Validators.maxLength(20)]),
      contactDetailsFormControl: new FormControl('', [Validators.maxLength(500)]),
       // Effective contact method checkbox
       emailCheckBoxFormControl: new FormControl('', []).clearValidators(),
       formUrlCheckBoxFormControl: new FormControl('', []).clearValidators(),
       phoneCheckBoxFormControl: new FormControl('', []).clearValidators(),
       faxCheckBoxFormControl: new FormControl('', []).clearValidators(),
    });
   }

selectedContactInfo: number;
selected: number;
locationArray: number;
model: any = {};
selectedSearchParameter;

mostRecentContact: string;
mostRecentContactFC: any;

// ContactLocationFormControl = new FormControl(this.passedData.contactId.toString());
ContactLocationFormControl = new FormControl();
  ContactLocationGroups: ContactLocationGroup[] = [
    {
      name: 'Contact Location',
      contactLocation: [
        {value: '0', viewValue: 'Unknown'},
        {value: '1', viewValue: 'Canada'},
        {value: '2', viewValue: 'USA'},
        {value: '3', viewValue: 'Europe'},
        {value: '4', viewValue: 'Other'}
      ]
    }
  ];

  emailCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      this.effectiveContactMethodArray.push(1);
      console.log(this.effectiveContactMethodArray);
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 1);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);
    }
  }

  formURLCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      console.log('form url checked');
      this.effectiveContactMethodArray.push(2);
      console.log(this.effectiveContactMethodArray);
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 2);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);
    }
  }


  phoneCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      console.log('phone checked');
      this.effectiveContactMethodArray.push(3);
      console.log(this.effectiveContactMethodArray);
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 3);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);    }
  }

  faxCheckBox($event) {
    console.log($event.checked);
    if ($event.checked) {
      console.log('fax checked');
      this.effectiveContactMethodArray.push(4);
      console.log(this.effectiveContactMethodArray);
    } else {
      const objIndex = this.effectiveContactMethodArray.findIndex(obj => obj == 4);
      if (objIndex > -1) {
        this.effectiveContactMethodArray.splice(objIndex, 1);
      }
      console.log(this.effectiveContactMethodArray);
      }
  }

  selectedContactLocation(event) {
    this.selectedSearchParameter = event.value;
  }

  loadedContactLocation(contactLocationId) {
    this.selectedSearchParameter = contactLocationId.toString();
  }

  ngOnInit() {
    this.loadManufacturer();
    this.mostRecentContactFC = this.editManufacturerForm.get('mostRecentContactFormControl');
    this.mostRecentContactFC.markAsTouched();
  }

  changeMostRecentContact(event) {
    this.mostRecentContact = event.target.value;
  }

  dontDeleteManufacturer() {
    this.confirmModal = false;
  }


  removeSelectedManufacturer() {
    this.confirmModal = true;
  }

ngAfterViewChecked() {
    const show = this.validateFormControl(this.editManufacturerForm);
    if (show != this.show) {
      this.show = show;
      this.cdr.detectChanges();
    }
    this.cdr.detectChanges();
  }

  public validateFormControl(control) {
    if (control.status === 'VALID') {
      return true;
    } else {
      return false;
    }
  }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  private validateEffectiveContactMethods() {
    // Email checkbox validation
    if (this.effectiveContactMethodArray.includes(1) && (!this.manufacturer.contactEmail || this.manufacturer.contactEmail.trim() === '')) {
      const index = this.effectiveContactMethodArray.indexOf(1);
      this.effectiveContactMethodArray.splice(index, 1);
      this.emailChecked = false;
      this.editManufacturerForm.get('emailCheckBoxFormControl').setValue(false);
    }
    
    // Form URL checkbox validation
    if (this.effectiveContactMethodArray.includes(2) && (!this.manufacturer.contactUrl || this.manufacturer.contactUrl.trim() === '')) {
      const index = this.effectiveContactMethodArray.indexOf(2);
      this.effectiveContactMethodArray.splice(index, 1);
      this.formUrlChecked = false;
      this.editManufacturerForm.get('formUrlCheckBoxFormControl').setValue(false);
    }
    
    // Phone checkbox validation
    if (this.effectiveContactMethodArray.includes(3) && (!this.manufacturer.contactPhoneNumber || this.manufacturer.contactPhoneNumber.trim() === '')) {
      const index = this.effectiveContactMethodArray.indexOf(3);
      this.effectiveContactMethodArray.splice(index, 1);
      this.phoneChecked = false;
      this.editManufacturerForm.get('phoneCheckBoxFormControl').setValue(false);
    }
    
    // Fax checkbox validation
    if (this.effectiveContactMethodArray.includes(4) && (!this.manufacturer.contactFaxNumber || this.manufacturer.contactFaxNumber.trim() === '')) {
      const index = this.effectiveContactMethodArray.indexOf(4);
      this.effectiveContactMethodArray.splice(index, 1);
      this.faxChecked = false;
      this.editManufacturerForm.get('faxCheckBoxFormControl').setValue(false);
    }
  }

  loadManufacturer() {
    return this.manufacturerService.getManufacturer(this.passedData.manufacturerId).subscribe(
      res => {
        this.manufacturer = res.body;
        console.log(this.manufacturer);
        
        this.loadedContactLocation(this.manufacturer.contactLocationId);
        
        if (this.manufacturer.mostrecentcontact) {
          this.mostRecentContact = this.manufacturer.mostrecentcontact;
        }

        this.manufacturerUrl = this.manufacturer.url;
        this.sdsURL = this.manufacturer.sdsUrl;

        if (this.manufacturer.effectiveContactMethod) {
          for (const method of this.manufacturer.effectiveContactMethod) {
            if (method === 1) {
              this.emailChecked = true;
              this.editManufacturerForm.get('emailCheckBoxFormControl').setValue(this.emailChecked);
              this.effectiveContactMethodArray.push(1);
            } else if (method === 2) {
              this.formUrlChecked = true;
              this.editManufacturerForm.get('formUrlCheckBoxFormControl').setValue(this.formUrlChecked);
              this.effectiveContactMethodArray.push(2);
            } else if (method === 3) {
              this.phoneChecked = true;
              this.editManufacturerForm.get('phoneCheckBoxFormControl').setValue(this.phoneChecked);
              this.effectiveContactMethodArray.push(3);
            } else if (method === 4) {
              this.faxChecked = true;
              this.editManufacturerForm.get('faxCheckBoxFormControl').setValue(this.faxChecked);
              this.effectiveContactMethodArray.push(4);
            }
          }
        }
        
        this.ContactLocationFormControl.setValue(this.manufacturer.contactLocationId.toString());
      });
  }

  onClickURL() {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(this.editManufacturerForm.get('urlFormControl').value)) {
        url += 'http://';
    }

    url += this.editManufacturerForm.get('urlFormControl').value;
    window.open(url, '_blank');
  }

  disabledURL() {
    if (this.editManufacturerForm.get('urlFormControl').value) {
      return false;
    } else {
      return true;
    }
  }

  onClickSDSURL() {
    let url: string = '';
    if (!/^http[s]?:\/\//.test(this.editManufacturerForm.get('sdsUrlFormControl').value)) {
        url += 'http://';
    }

    url += this.editManufacturerForm.get('sdsUrlFormControl').value;
    window.open(url, '_blank');
  }

  disabledSDSURL() {
    if (this.editManufacturerForm.get('sdsUrlFormControl').value) {
      return false;
    } else {
      return true;
    }
  }

  removeManufacturer() {
    this.loading = true;
    return this.manufacturerService.deleteManufacturer(this.passedData.manufacturerId).subscribe(
      res => {
        this.checkProductManufacturer = res.headers.get('productManufacturerExists');
        if (this.checkProductManufacturer) {
          this.alertify.error(this.checkProductManufacturer);
          this.loading = false;
        } else {
          this.isDeleted = true;
          this.loading = false;
          this.alertify.success('Company has been deleted');
          this.dialog.closeAll();
        }
      });
  }

  editManufacturer() {
    this.model.name = this.manufacturer.manufacturerName.trim();
    this.model.url = this.manufacturer.url.trim();
    this.model.msdsUrl = this.manufacturer.sdsUrl.trim();

    this.model.manufacturerAlias = this.manufacturer.alternateName.toString();

    this.model.contactLocationId = this.selectedSearchParameter.toString();
    this.model.notes = this.manufacturer.notes.trim();
    this.model.mostrecentcontact = this.mostRecentContact;
    this.model.contactEmail = this.manufacturer.contactEmail.trim();
    if (this.manufacturer.contactUrl) {
      this.model.contactUrl = this.manufacturer.contactUrl.trim();
    } else {
      this.model.contactUrl = '';
    }
    this.model.contactPhoneNumber = this.manufacturer.contactPhoneNumber.trim();
    this.model.contactFaxNumber = this.manufacturer.contactFaxNumber.trim();
    this.model.contactDetails = this.manufacturer.contactDetails.trim();
    this.validateEffectiveContactMethods();
    this.model.effectiveContactMethod = this.effectiveContactMethodArray.length == 0 ? null : this.effectiveContactMethodArray;
    return this.manufacturerService.UpdateManufacturers(this.passedData.manufacturerId, this.model).subscribe(res => {
      this.manu = res;
      if (this.passedData.serverSideSearch !== undefined) {
        this.passedData.serverSideSearch.bankServerSideCtrl.setValue(this.passedData.manufacturerId);
        if (this.passedData.selectedManu !== undefined) {
          this.passedData.serverSideSearch.bankServerSideFilteringCtrl.setValue(this.passedData.selectedManu.manufacturerName);
          console.log('manufacturer');
          this.passedData.serverSideSearch.placeholder = this.passedData.selectedManu.manufacturerName;
        } else {
          this.passedData.serverSideSearch.bankServerSideFilteringCtrl.setValue(this.manu.name);
          console.log('manufacturer');
          this.passedData.serverSideSearch.placeholder = this.manu.name;
        }
      }
      this.isModified = true;
      this.alertify.success('Company has been updated');
    }, error => {
      this.alertify.error('Error');
    });
  }
}

export interface ContactLocationCategory {
  value: string;
  viewValue: string;
}

export interface ContactLocationGroup {
  disabled?: boolean;
  name: string;
  contactLocation: ContactLocationCategory[];
}